import React from 'react';
import './QueueStatusPanel.less';
import { useDispatch, useSelector } from 'react-redux';
import { offlineActions, offlineSelectors } from '../../../redux/offline';
import Icon from '../../../components/envago/Icon/Icon';
import Button from '../../../components/envago/Button/Button';
import classNames from 'classnames';
import queueSelectors from '../../../redux/offline/queue.selectors';
import Dialog from '../../../components/envago/Dialog/Dialog';
import Information, { InformationType } from '../../../components/envago/Information/Information';
import { useTranslation } from 'react-i18next';

const QueueStatusPanel = ({}) => {

    const { t } = useTranslation();

    const queueLength = useSelector(queueSelectors.getQueueLength);
    const isQueueSending = useSelector(offlineSelectors.isQueueSending);
    const isOnline = useSelector(offlineSelectors.isOnline);
    const dispatch = useDispatch();
    const hasDialogBeenShown = useSelector(offlineSelectors.hasDialogBeenShown);

    if (queueLength === 0) return null;

    return (
        <>
            <Dialog
                visible={!isOnline && !hasDialogBeenShown}
                title={'Achtung: Keine Internetverbindung'}
                actions={[
                    <Button
                        onClick={() => {
                            dispatch(offlineActions.offlineMessageShown());
                        }}
                        key={'close-btn'}
                    >
                        {t('offline.buttons.close')}
                    </Button>,
                ]}
            >
                <Information type={InformationType.WARNING}>
                    {t('offline.warning')}
                </Information>

                <p className={'md:max-w-screen-sm mt-4'}>
                    <b>
                        {t('offline.description')}
                    </b>
                </p>

                <p className={'md:max-w-screen-sm mt-4'}>
                    {t('offline.details')}
                </p>
            </Dialog>

            <div className={classNames(
                'queue-status-panel z-30 md:fixed md:right-1 md:bottom-1 md:mt-2 p-2 md:bg-yellow-50 md:text-inherit shadow-xl text-sm flex md:flex-row flex-col items-center rounded-md',
                {
                    'bg-red-100 text-red-900': !isOnline,
                    'bg-blue-50 text-blue-900': isOnline,
                },
            )}>
                <div className={'flex'}>
                    <Icon
                        path={isOnline ? Icon.Path.mdiCloudUploadOutline : Icon.Path.mdiAlertCircleOutline}
                        className={classNames('h-6 self-center justify-self-center mr-2', {
                            'text-red-900 md:text-yellow-600': !isOnline,
                            'text-blue-900 md:text-blue-600': isOnline,
                        })}
                    />
                    <div className={'flex flex-1 md:mr-4 items-center'}>
                        <div className={'md:hidden'}>
                            {isOnline
                                ? t('offline.infopanel.messageMobileOnline', {queueLength})
                                : t('offline.infopanel.messageMobile', {queueLength})}
                        </div>
                        <div className={'hidden md:block'}>
                            {isOnline
                                ? t('offline.infopanel.messageOnline', {queueLength})
                                : t('offline.infopanel.message', {queueLength})}
                        </div>
                        {!isOnline && (
                            <div className={'text-xs hidden md:block'}>
                                {t('offline.infopanel.details')}
                            </div>
                        )}
                    </div>
                </div>
                <div className={'hidden md:flex justify-end'}>
                    <Button
                        className={'md:inline'}
                        primary={true}
                        small={true}
                        disabled={isQueueSending}
                        onClick={() => {
                            dispatch(offlineActions.queueTrySend());
                        }}
                    >
                        <Icon
                            path={Icon.Path.mdiRefreshCircle}
                            className={classNames('mr-2 h-6', {
                                'animate-spin': isQueueSending,
                            })}
                        />
                        {t('offline.buttons.retry')}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default QueueStatusPanel;
